import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GridSortModel } from '@mui/x-data-grid';
import MaterialTable from '../../components/dataTable/MaterialTable/MaterialTable';
import useGamers, { GamersOrderBy } from '../../hooks/api/users/useGamers';
import { routes } from '../../static/routes';
import { searchParamsData } from '../../static/searchParamsData';
import useGamersTableHeaders from './hooks/useGamersTableHeaders';

const pageSize = 20;

const GamersList = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pageParam = searchParams.get(searchParamsData.page);
  const page = !!pageParam && +pageParam > 0 ? +pageParam : 1;

  // GMT-802: sorting is done server-side, so it covers the whole dataset,
  // not only the rows of the current page.
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const orderBy = sortModel[0]?.field as GamersOrderBy | undefined;
  const sort = sortModel[0]?.sort === 'asc' ? 'ASC' : sortModel[0]?.sort === 'desc' ? 'DESC' : undefined;

  const { gamers, isLoading } = useGamers({ page: page, limit: pageSize, orderBy, sort });
  const { headers } = useGamersTableHeaders();

  return (
    <div className="pb-36">
      <MaterialTable
        key={page}
        columns={headers}
        rowCount={gamers?.count ?? 0}
        rows={gamers.data ?? []}
        loading={isLoading}
        showPagination
        paginationMode="server"
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={model => {
          setSortModel(model);
          navigate(routes.allGamers({ page: 1 }));
        }}
        paginationModel={{
          page: page - 1,
          pageSize,
        }}
        onPaginationModelChange={e => {
          navigate(routes.allGamers({ page: e.page + 1 }));
        }}
      />
    </div>
  );
};

export default GamersList;
